import { create } from "zustand";

const REPORTING_MOCK_DATA_STORAGE_KEY = "reporting-use-mock-data";

type ReportingMockDataState = {
  useMockData: boolean;
  setUseMockData: (value: boolean) => void;
};

export const useReportingMockData = create<ReportingMockDataState>((set) => ({
  useMockData:
    typeof window !== "undefined" &&
    localStorage.getItem(REPORTING_MOCK_DATA_STORAGE_KEY) === "true",
  setUseMockData: (value: boolean) => {
    localStorage.setItem(REPORTING_MOCK_DATA_STORAGE_KEY, String(value));
    set({ useMockData: value });
  },
}));
